<template>
		<div>
			<div fillHeight="lastHeight" scroll>
				<div  class="w90pct mc mt2x" style="min-height:20em">
					<div class="panel bgPanel mb1x mt1x pl2x pt2x pb2x pr2x emptyToken_EE" v-if="crawlConfig">
						<ul class="bdSub-bottom pb1x">
							<li class="dpIB_E w100pct"><span class="w50pct b fs12x" :title="getLanguageStr('word1718','系统信息')">{{getLanguageStr('word1718','系统信息')}}</span></li>
							<li class="dpIB_E w100pct mt1x cb clearfix">
								<span class="w50pct fL" :title="getLanguageStr('plant314','系统名称')">{{getLanguageStr('plant314','系统名称')}}</span>
								<span class="w50pct fL" :title="getSystemName">{{getSystemName}}</span>
							</li>
							<li class="dpIB_E w100pct mt1x cb clearfix">
								<span class="w50pct fL" :title="getLanguageStr('plant312','系统域名')">{{getLanguageStr('plant312','系统域名')}}</span>
								<span class="w50pct fL" :title="crawlConfig.source.siteDomain">{{crawlConfig.source.siteDomain}}</span>
							</li>
							<li class="dpIB_E w100pct mt1x cb clearfix">
								<span class="w50pct fL" :title="getLanguageStr('plant313','登录账号')">{{getLanguageStr('plant313','登录账号')}}</span>
								<span class="w50pct fL" :title="crawlConfig.source.accountName">{{crawlConfig.source.accountName}}</span>
							</li>
							<li class="dpIB_E w100pct mt1x cb clearfix">
								<span class="w50pct fL" :title="$t('creat_plant17',['电站名称'])">{{$t('creat_plant17',['电站名称'])}}</span>
								<span class="w50pct fL" :title="crawlConfig.source.stationName">{{crawlConfig.source.stationName}}</span>
							</li>
						</ul>
						<ul class="pt1x" v-if="CrawlStats">
							<li class="dpIB_E w100pct"><span class="w50pct b fs12x" :title="$t('word1409',['采集信息'])">{{$t('word1409',['采集信息'])}}</span></li>
							<li class="dpIB_E w100pct mt1x cb clearfix" v-if="crawlConfig">
								<span class="w50pct fL" :title="$t('word1410',['采集状态'])">{{$t('word1410',['采集状态'])}}</span>
								<span class="w50pct fL cMain"><span v-if="crawlConfig.disabled==false">{{$t('word1411',['采集中'])}}</span><span v-if="crawlConfig.disabled==true">{{$t('word1412',['已停止'])}}</span></span>
							</li>
							<li class="dpIB_E w100pct mt1x cb clearfix">
								<span class="w50pct fL" :title="$t('word1413',['最近采集时间'])">{{$t('word1413',['最近采集时间'])}}</span>
								<span class="w50pct fL"  v-if="CrawlStats.latestRecord" :title="CrawlStats.latestRecord.createTime|time('%Y/%m/%d %H:%M:%S','inc')">{{CrawlStats.latestRecord.createTime|time('%Y/%m/%d %H:%M:%S','inc')}}</span>
							</li>
							<li class="dpIB_E w100pct mt1x cb clearfix">
								<span class="w50pct fL" :title="getLanguageStr('device240','当日采集数量')">{{getLanguageStr('device240','当日采集数量')}}</span>
								<span class="w50pct fL" :title="CrawlStats.todayTotalCount">{{CrawlStats.todayTotalCount}}</span>
							</li>
							<li class="dpIB_E w100pct mt1x cb clearfix">
								<div class="w50pct fL">
									<span :title="getLanguageStr('device239','当日故障数量')">{{getLanguageStr('device239','当日故障数量')}}</span>
									<help class="helpBtn_pythonInfo" :code="'plant-1'" :btnClose="false" :helpTipMessage="getLanguageStr('device236','当日故障数量>0,说明当日的采集出现故障,请点击“导出近60日故障数据”查看故障原因。')"></help>
								</div>
								<span class="w50pct fL" :title="CrawlStats.todayErrorCount">{{CrawlStats.todayErrorCount}}</span>
							</li>
							<li class="dpIB_E w100pct mt1x cb clearfix">
								<span class="w50pct fL" :title="getLanguageStr('device241','近60日采集数量')">{{getLanguageStr('device241','近60日采集数量')}}</span>
								<span class="w50pct fL" :title="CrawlStats.day60TotalCount">{{CrawlStats.day60TotalCount}}</span>
							</li>
							<li class="dpIB_E w100pct mt1x cb clearfix">
								<div class="w50pct fL">
									<span :title="getLanguageStr('manage357','近60日故障数量')">{{getLanguageStr('manage357','近60日故障数量')}}</span>
									<help class="helpBtn_pythonInfo" :code="'plant-1'" :btnClose="false" :helpTipMessage="getLanguageStr('device237','近60日故障数量>0,说明近60日的采集出现故障，请点击“导出近60日故障数据”查看故障原因。')"></help>
								</div>
								<span class="w50pct fL" :title="CrawlStats.day60ErrorCount">{{CrawlStats.day60ErrorCount}}</span>
							</li>
							<li class="dpIB_E w100pct mt1x cb clearfix">
								<div class="w50pct fL">
									<span :title="$t('word1452',['最近采集数据'])">{{$t('word1452',['最近采集数据'])}}</span>
									<help class="helpBtn_pythonInfo" :code="'plant-1'" :btnClose="false" :helpTipMessage="getLanguageStr('device238','最近采集数据为--，说明当前采集出现故障，请点击“导出近60日故障数据”查看故障原因。')"></help>
								</div>
								<div class="w50pct fL">
									<div>
										{{$t('word176',['发电功率'])+':&nbsp;'}}<span class="mr1x" :title="convertData(CrawlStats.latestRecord.generationPower,2,'','W')[0]" v-if="CrawlStats.latestRecord">{{convertData(CrawlStats.latestRecord.generationPower,2,'','W')[0]}}</span>
									</div>
									<div class="mt05x">
										{{$t('word358',['当日发电量'])+':&nbsp;'}}<span class="mr1x" :title="convertData(CrawlStats.latestRecord.generationToday,2,'k','Wh')[0]" v-if="CrawlStats.latestRecord">{{convertData(CrawlStats.latestRecord.generationToday,2,'k','Wh')[0]}}</span>
									</div>
									<div class="mt05x">
										{{$t('word357',['累计发电量'])+':&nbsp;'}}<span class="mr1x" :title="convertData(CrawlStats.latestRecord.generationTotal,2,'k','Wh')[0]" v-if="CrawlStats.latestRecord">{{convertData(CrawlStats.latestRecord.generationTotal,2,'k','Wh')[0]}}</span>
									</div>
								</div>
							</li>
						</ul>
					</div>
					<div class="taC vaM_E" v-if="crawlConfig">
						<button class="functionBtn w10x mt4x mr2x" type="button" @click="GET_CRAWLSHOW(false)">{{$t('cmd8',['编辑'])}}</button>
						<button class="functionBtn w12x mt4x mr2x" type="button" @click="downLoad">{{getLanguageStr('device242','导出近60日故障数据')}}</button>
						<button class="functionBtn w10x mt4x" type="button" @click="_crawlProcess"><span v-if="crawlConfig.disabled==false">停止采集</span><span v-if="crawlConfig.disabled==true">启动采集</span></button>
					</div>
				</div>
			</div>
		</div>
</template>
<script>
import { mapGetters,mapMutations,mapActions } from 'vuex'
import InputText from "@/components/common/ui/InputText"
import Loading from '@/components/common/ui/Loading'
import Help from '@/components/common/Help'
import Select from "@/components/common/ui/Select.vue";
import * as lib from "@/util/lib.js";
import {getLanguageStr} from "@/util/language"

import * as configApi from '@/api/maintain/config'
export default {
	name: 'stationPythonInfo',
	components:{
		InputText,
		Loading,
		Help,
		Select
	},
	data(){
		return{
			result:null
		}
	},
	props:{
		systemNameList:{
			type:Array,
			default:function(){return new Array();}
		}
	},
	computed:{
		...mapGetters({
			stationId: 'stationDetail/stationId',
			crawlConfig:'stationConfig/crawlConfig',
			CrawlStats:'stationConfig/CrawlStats'
		}),
		getSystemName(){
			return lib.getObjArray(this.systemNameList,this.crawlConfig.source.type,"value","text")
		}
	},
	methods:{
		convertData:lib.convertData,
		...mapMutations({
			GET_CRAWLSHOW:'stationConfig/GET_CRAWLSHOW'
		}),
		...mapActions({
			GETCRAWLCONFIG:'stationConfig/GETCRAWLCONFIG',
			GETCRAWSTATS:'stationConfig/GETCRAWSTATS'
		}),
		getLanguageStr,
		show(){
			// this.getCrawlStats(this.stationId)
			// this.GETCRAWLCONFIG(this.stationId)
		},
		getCrawlStats(id){
			this.GETCRAWSTATS(id)
		},
		//启停
		_crawlProcess(){
			let req={
				disabled:!this.crawlConfig.disabled
			}
			configApi.crawlProcess(this.stationId,req).then(res=>{
				this.GETCRAWLCONFIG(this.stationId)
			},error=>{
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		//下载
		downLoad(){
			configApi.downLoadCrawl(this.stationId).then(res=>{
				let blob = new Blob([res])
				let downloadElement = document.createElement('a')
				let href = window.URL.createObjectURL(blob) //创建下载的链接
				downloadElement.href = href
				downloadElement.download = getLanguageStr('device243','故障数据')+`.xlsx`; //下载后文件名
				document.body.appendChild(downloadElement)
				downloadElement.click() //点击下载
				document.body.removeChild(downloadElement) //下载完成移除元素
				window.URL.revokeObjectURL(href) //释放掉blob对象
			})
		}
	}
}
</script>
<style lang="scss">
.helpBtn_pythonInfo{
	position: absolute;
	/*left:0;*/
	margin-top:-.5em;
	margin-left: .5em;
	.tip{bottom: auto;white-space:normal;overflow:visible;padding:0;left:auto;} 
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/StationPythonInfo.vue